import { localStorage } from 'src/utils/localStorage';

const TENANT_LOCAL_STORAGE_KEY = 'vp-upload-and-print-tenant';

let tenant: string;
let tenantOverride: string | null;

export function isDevelopmentMode(): boolean {
  const href = window.location.href;
  const isNonProductionUrl =
    href.startsWith('https://upload-and-print.s3.amazonaws.com/') || // Static site S3 bucket
    href.startsWith('https://client.upload-and-print.design.vpsvc.com/') || // Static site CDN
    href.match(/https:\/\/.*-review-.*\.design\.vpsvc\.com\//) !== null; // Review apps for CDN-backed sites

  return process.env.NODE_ENV !== 'production' || isNonProductionUrl;
}

export function isProdTenant(): boolean {
  if (getTenant() === 'default' || getTenant() === '') {
    return true;
  }
  return false;
}

function getDefaultTenant() {
  return isDevelopmentMode() ? 'dev' : '';
}

function getTenantOverride() {
  if (tenantOverride === undefined) {
    const tenantFromQuery = new URLSearchParams(window.location.search).get('tenant');
    if (tenantFromQuery !== null) {
      localStorage.set(TENANT_LOCAL_STORAGE_KEY, tenantFromQuery);
      tenantOverride = tenantFromQuery;
    } else {
      tenantOverride = localStorage.get(TENANT_LOCAL_STORAGE_KEY);
    }
  }

  return tenantOverride;
}

export function getTenant(): string {
  if (tenant === undefined) {
    const tenantOverride = getTenantOverride();
    tenant = tenantOverride !== null ? tenantOverride : getDefaultTenant();
  }

  return tenant;
}
